"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: check-deposit/check-deposit-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcheck-deposit%2Fcheck-deposit-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckDepositServiceClient = exports.GetEligibilityResponse = exports.GetEligibilityRequest = exports.GetEnrollmentResponse = exports.GetEnrollmentRequest = exports.EnrollUserResponse = exports.EnrollUserRequest = exports.DepositCheckResponse = exports.DepositCheckRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const eligibility_requirement_1 = require("./eligibility-requirement");
const protobufPackage = 'com.step.checkdeposit.proto';
function createBaseDepositCheckRequest() {
    return {
        amount: amount_1.Amount.fromPartial({}),
        frontImage: '',
        backImage: '',
        destinationAccountId: '',
        note: '',
    };
}
exports.DepositCheckRequest = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            frontImage: isSet(object.frontImage) ? globalThis.String(object.frontImage) : '',
            backImage: isSet(object.backImage) ? globalThis.String(object.backImage) : '',
            destinationAccountId: isSet(object.destinationAccountId)
                ? globalThis.String(object.destinationAccountId)
                : '',
        };
        if (isSet(object.note)) {
            message.note = globalThis.String(object.note);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.frontImage !== '') {
            obj.frontImage = message.frontImage;
        }
        if (message.backImage !== '') {
            obj.backImage = message.backImage;
        }
        if (message.destinationAccountId !== '') {
            obj.destinationAccountId = message.destinationAccountId;
        }
        if (message.note !== undefined && message.note !== '') {
            obj.note = message.note;
        }
        return obj;
    },
    create(base) {
        return exports.DepositCheckRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDepositCheckRequest();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.frontImage = object.frontImage ?? '';
        message.backImage = object.backImage ?? '';
        message.destinationAccountId = object.destinationAccountId ?? '';
        message.note = object.note ?? '';
        return message;
    },
};
function createBaseDepositCheckResponse() {
    return { paymentId: '' };
}
exports.DepositCheckResponse = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.DepositCheckResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDepositCheckResponse();
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseEnrollUserRequest() {
    return {};
}
exports.EnrollUserRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.EnrollUserRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseEnrollUserRequest();
        return message;
    },
};
function createBaseEnrollUserResponse() {
    return {};
}
exports.EnrollUserResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.EnrollUserResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseEnrollUserResponse();
        return message;
    },
};
function createBaseGetEnrollmentRequest() {
    return {};
}
exports.GetEnrollmentRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetEnrollmentRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetEnrollmentRequest();
        return message;
    },
};
function createBaseGetEnrollmentResponse() {
    return { isEnrolled: false };
}
exports.GetEnrollmentResponse = {
    fromJSON(object) {
        const message = {
            isEnrolled: isSet(object.isEnrolled) ? globalThis.Boolean(object.isEnrolled) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isEnrolled !== false) {
            obj.isEnrolled = message.isEnrolled;
        }
        return obj;
    },
    create(base) {
        return exports.GetEnrollmentResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetEnrollmentResponse();
        message.isEnrolled = object.isEnrolled ?? false;
        return message;
    },
};
function createBaseGetEligibilityRequest() {
    return {};
}
exports.GetEligibilityRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetEligibilityRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetEligibilityRequest();
        return message;
    },
};
function createBaseGetEligibilityResponse() {
    return { isEligible: false, isEnrolled: false, isBlocked: false, requirements: [] };
}
exports.GetEligibilityResponse = {
    fromJSON(object) {
        const message = {
            isEligible: isSet(object.isEligible) ? globalThis.Boolean(object.isEligible) : false,
            isEnrolled: isSet(object.isEnrolled) ? globalThis.Boolean(object.isEnrolled) : false,
            isBlocked: isSet(object.isBlocked) ? globalThis.Boolean(object.isBlocked) : false,
            requirements: globalThis.Array.isArray(object?.requirements)
                ? object.requirements.map((e) => eligibility_requirement_1.EligibilityRequirement.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isEligible !== false) {
            obj.isEligible = message.isEligible;
        }
        if (message.isEnrolled !== false) {
            obj.isEnrolled = message.isEnrolled;
        }
        if (message.isBlocked !== false) {
            obj.isBlocked = message.isBlocked;
        }
        if (message.requirements?.length) {
            obj.requirements = message.requirements.map((e) => eligibility_requirement_1.EligibilityRequirement.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetEligibilityResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetEligibilityResponse();
        message.isEligible = object.isEligible ?? false;
        message.isEnrolled = object.isEnrolled ?? false;
        message.isBlocked = object.isBlocked ?? false;
        message.requirements = object.requirements?.map((e) => eligibility_requirement_1.EligibilityRequirement.fromPartial(e)) ||
            [];
        return message;
    },
};
/**
 * Check Deposit public API.
 */
class CheckDepositServiceClient {
    rpc;
    name = 'com.step.checkdeposit.proto.CheckDepositService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/check-deposit';
    methods = [{
            name: 'GetEligibility',
            requestType: exports.GetEligibilityRequest,
            responseType: exports.GetEligibilityResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'DepositCheck',
            requestType: exports.DepositCheckRequest,
            responseType: exports.DepositCheckResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'EnrollUser',
            requestType: exports.EnrollUserRequest,
            responseType: exports.EnrollUserResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetEnrollment',
            requestType: exports.GetEnrollmentRequest,
            responseType: exports.GetEnrollmentResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Checks user eligibility for check deposit.
     */
    getEligibility(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Deposit a check for the user.
     */
    depositCheck(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Enroll user into check deposit services.
     */
    enrollUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get check deposit enrollment status.
     */
    getEnrollment(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.CheckDepositServiceClient = CheckDepositServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=check-deposit-service.js.map